import netsChatSms from './nets-chat-sms';
import moduleConfig from './module-config';

export default angular
  .module('app.chat', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsChatSms', netsChatSms);
